module.exports = __webpack_public_path__ + "static/media/blue-grey10.70c8a43c.png";